import React from 'react';
import { View, Pressable, ScrollView } from 'react-native';
import { Text } from '@/components/ui/text';

interface WelcomeScreenProps {
  onNext: () => Promise<void>;
  isAdvancing: boolean;
}

export function WelcomeScreen({ onNext, isAdvancing }: WelcomeScreenProps) {
  return (
    <ScrollView
      className="flex-1"
      showsVerticalScrollIndicator={false}
      contentContainerStyle={{ flexGrow: 1, justifyContent: 'center', alignItems: 'center', paddingHorizontal: 24 }}
    >
      <View className="items-center mb-12">
        <Text className="text-4xl font-bold text-foreground mb-2">Flavrly</Text>
        <Text className="text-lg text-muted-foreground text-center">
          Eat Like a Local
        </Text>
      </View>

      <Text className="text-base text-muted-foreground text-center mb-8 px-4">
        Discover dishes worth trying, track where you've been, and share your favorites with friends.
      </Text>

      <Pressable
        onPress={onNext}
        disabled={isAdvancing}
        accessibilityLabel="Get started"
        className="bg-primary rounded-lg py-3 px-8"
        style={{ opacity: isAdvancing ? 0.5 : 1 }}
      >
        <Text className="text-primary-foreground text-base font-semibold text-center">
          {isAdvancing ? 'Loading...' : 'Get started'}
        </Text>
      </Pressable>
    </ScrollView>
  );
}
